import { render, staticRenderFns } from "./ModalDecisions.vue?vue&type=template&id=2bcb452e&"
import script from "./ModalDecisions.vue?vue&type=script&lang=js&"
export * from "./ModalDecisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports